import React, { useState } from "react";
import { Link } from "react-router-dom";
import calls from "apis/calls";
import { useNavigate } from "react-router-dom";
function EnterRecoveryPhase() {
    const navigate = useNavigate();
    const [key, setSecretKey] = useState("");
    const handleChange = (e) => {
      // const value = e.target.value;
      // let newArr = [...key]
      // newArr[index] = value
      setSecretKey(e.target.value);
    };
    console.log(key);

    const next = async () => {
      const phrase = await calls.getSecretphrase();
      const inn = key.split(",").join(" ");
      // const inn = key;
      console.log(inn);
      if (phrase === inn) {
        navigate("/congrats");
      }
    };

    return (
      <div>
        <div className="bg-img-main">
          <div className="bg-img"></div>
        </div>

        {/* ========================Home-Banner===================  */}
        <section id="banner">
          <div className="custom-container">
            <div className="sec-padding">
              <div className="row">
                <div className="col-lg-12">
                  <div className="main">
                    <div className="box">
                      <div className="heading">
                        <h2>Write Down Your Secret Recovery Phase</h2>
                      </div>
                    </div>
                    <div className="box">
                      <div className="row w-100">
                        <div className="col-12">
                          <input
                            type="text"
                            name="one"
                            value={key}
                            // onChange={(e) => handleChange(e, 0)}
                            onChange={handleChange}
                            className={"wallet-address"}
                            placeholder={"Enter your secret Keys"}
                          />
                        </div>
                      </div>
                    </div>

                    <div class="send-btn mt-5">
                      <button type="submit" onClick={next} class="btn w-100">
                        <span> Submit</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
}

export default EnterRecoveryPhase;
